import React, { useState, useEffect } from "react";
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import arrowleft from "../../../assets/icons/Arrow/left.svg";
import PlaceholderB from "../../../assets/components/PlaceholderB"
import { FillButton, GrayButton } from "../../../assets/components/ButtonGroup";
import { Chip } from "../../../assets/components/Chip";
import {
  fetchSiksinMenus,
  fetchSiksinMenusByBusinessNumber,
} from "../../../utils/siksinMenus";

const EventAI1 = ({ data, updateData, userMenu, onNext, onBack }) => {
  const [attempted, setAttempted] = useState(false);
  // const isValid = !!data.category || !!data.customMenu?.trim();
  const customMenu = (data?.customMenu ?? "").trim();
  const isValid = customMenu.length > 0 && customMenu !== "null";
  const [hasInitialized, setHasInitialized] = useState(false);
  const [recommendedMenus, setRecommendedMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);

  const localStoreId =
    localStorage.getItem("local_store_id")
      ? Number(localStorage.getItem("local_store_id"))
      : null;
  const storeBusinessNumber = localStorage.getItem("store_business_number") || "";

  useEffect(() => {
    if (!hasInitialized && !data.customMenu && userMenu) {
      updateData({ customMenu: userMenu });
      setHasInitialized(true);
    }
  }, [hasInitialized, data.customMenu, userMenu, updateData]);

  useEffect(() => {
    let alive = true;

    (async () => {
      const menus = localStoreId
        ? await fetchSiksinMenus(localStoreId)
        : await fetchSiksinMenusByBusinessNumber(storeBusinessNumber);
      if (!alive) return;

      const nextRecommended = Array.isArray(menus) ? menus.slice(0, 12) : [];
      setRecommendedMenus(nextRecommended);

      const currentValue =
        data?.customMenu && data.customMenu !== "null" ? data.customMenu : "";
      const matched = nextRecommended.find((m) => m === currentValue) || null;
      setSelectedMenu(matched);
    })();

    return () => {
      alive = false;
    };
  }, [localStoreId, storeBusinessNumber]);


  const handleCustomInput = (e) => {
    const nextValue = e.target.value;
    updateData({
      customMenu: nextValue,
      category: "", // 버튼 선택값 초기화
    });
    setSelectedMenu(nextValue === selectedMenu ? selectedMenu : null);
  };

  const applyMenu = (menu) => {
    const nextValue = String(menu || "");
    setSelectedMenu(nextValue);
    updateData({
      customMenu: nextValue,
      category: "",
    });
  };

  return (
    <div className="min-h-screen">
      <HeaderIconL
        title="AI 이미지 생성"
        icon={arrowleft}
        onIconClick={onBack}
      />

      <div className="p-[16px] gap-[8px] flex flex-col">
        <div className="text-t2 text-text-default">어떤 상품을 이미지로 생성할까요?</div>
        <div className="text-b1 text-text-subtler">마케팅 이미지에 넣고 싶은 상품을 작성해 주세요.</div>
      </div>

      <div className="pt-[32px] px-[16px]">        
        <PlaceholderB 
          label="상품명"
          placeholder="예) 삼겹살/아메리카노/송편"
          showCounter
          value={data?.customMenu && data.customMenu !== "null" ? data.customMenu : ""}
          onChange={handleCustomInput}
          rightIconMode="clear"
          maxLength={20}
        />        
      </div>

      {recommendedMenus.length > 0 && (
        <div className="mt-4 px-[16px] flex flex-wrap gap-2">
          {recommendedMenus.map((m) => (
            <Chip
              key={m}
              chip="d"
              status={m === selectedMenu ? "selected" : "default"}
              className={
                m === selectedMenu
                  ? "bg-surface-light-white border-black text-black"
                  : ""
              }
              label={m}
              onClick={() => applyMenu(m)}
            />
          ))}
        </div>
      )}

      {attempted && !isValid && (
        <p className="text-lg text-red-500 pt-2">
          홍보 내용을 입력해주세요.
        </p>
      )}

      <div className="fixed bottom-0 left-0 right-0">
        {isValid ? (
          <FillButton className="w-full" onClick={() => {
            setAttempted(true);
            if (!isValid) return;

            const refined = {
              ...data,
              category: data.category || "",
              customMenu: data.customMenu || "",
            };

            // 둘 중 하나만 값 유지
            if (refined.category) refined.customMenu = "";
            if (refined.customMenu) refined.category = "";

            updateData(refined);
            onNext();
          }}>
              다음
          </FillButton>
      ) : (
          <GrayButton className="w-full" disabled>
              다음
          </GrayButton>
      )}
      </div>
    </div>
  );
};

export default EventAI1;
